export function formatPatientAddress(
    street: string | null,
    houseNumber: string | null,
    neighborhood: string | null,
    city: string | null,
    state: string | null,
    zipCode: string | null,
) {
    const addressParts: string[] = [];
    const locationParts: string[] = [];
    
    if (street) {
        const streetPart = houseNumber ? `${street}, ${houseNumber}` : street;

        addressParts.push(streetPart);
    }
    
    if (neighborhood) {
        addressParts.push(neighborhood);
    }
    
    if (city) {
        locationParts.push(city);
    }

    if (state) {
        locationParts.push(state);
    }
    if (Boolean(locationParts.length)) {
        addressParts.push(locationParts.join("/"));
    }
    
    if (zipCode) {
        addressParts.push(zipCode);
    }
    
    return addressParts.join(" - ") || "Endereço não informado";
}
